// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"236":"984fe180","513":"122d65a1","703":"b57c4fbc","787":"1fe1b3e5"}[chunkId] + ".chunk.js";
};